module.exports = __webpack_public_path__ + "media/images/help/flow/bg-rail-04-1fa1b78a616abac7c112adc130e7f299.svg";